import { render, staticRenderFns } from "./SourcePanel.vue?vue&type=template&id=4a5583c4&"
import script from "./SourcePanel.vue?vue&type=script&lang=js&"
export * from "./SourcePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports